<template>
  <div id="offer-cards" class="container">

<!--      IM-->
      <div class="row mb-4 mt-5">
        <div class="col-12 text-center"><h1>{{ im }}</h1></div>
        <div class="col-12 text-center"><p>{{ subim }}</p></div>
      </div>

      <div class="row mb-5 d-flex justify-content-center">
        <div class="col-12 col-sm-6 mb-4">

          <div class="card mx-auto border-0" style="max-width: 28rem;">
            <img src="/img/pre/dummyProduct.jpg" class="card-img-top" alt="">
            <div class="card-body text-center pt-5 pb-5">
              <h5 class="card-title">Producto</h5>
              <p class="card-text">sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus</p>
              <a href="#" class="btn btn-primary">COMPRAR</a>
            </div>
          </div>

        </div>

        <div class="col-12 col-sm-6 mx-auto mb-4">

          <div class="card mx-auto border-0" style="max-width: 28rem;">
            <img src="/img/pre/dummyProduct.jpg" class="card-img-top" alt="">
            <div class="card-body text-center pt-5 pb-5">
              <h5 class="card-title">Producto</h5>
              <p class="card-text">sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus</p>
              <a href="#" class="btn btn-primary">COMPRAR</a>
            </div>
          </div>

        </div>


      </div>

<!--    TVAV-->

    <div class="row mb-4 mt-5">
      <div class="col-12 text-center"><h1>{{ tvav }}</h1></div>
      <div class="col-12 text-center"><p>{{ subtvav }}</p></div>
    </div>

    <div class="row mb-5 d-flex justify-content-center">
      <div class="col-12 col-sm-6 mb-4">

        <div class="card mx-auto border-0" style="max-width: 28rem;">
          <img src="/img/pre/dummyProduct.jpg" class="card-img-top" alt="">
          <div class="card-body text-center pt-5 pb-5">
            <h5 class="card-title">Producto</h5>
            <p class="card-text">sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus</p>
            <a href="#" class="btn btn-primary">COMPRAR</a>
          </div>
        </div>

      </div>

      <div class="col-12 col-sm-6 mx-auto mb-4">

        <div class="card mx-auto border-0" style="max-width: 28rem;">
          <img src="/img/pre/dummyProduct.jpg" class="card-img-top" alt="">
          <div class="card-body text-center pt-5 pb-5">
            <h5 class="card-title">Producto</h5>
            <p class="card-text">sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus</p>
            <a href="#" class="btn btn-primary">COMPRAR</a>
          </div>
        </div>

      </div>


    </div>

    <!--    DA-->

    <div class="row mb-4 mt-5">
      <div class="col-12 text-center"><h1>{{ da }}</h1></div>
      <div class="col-12 text-center"><p>{{ subda }}</p></div>
    </div>

    <div class="row mb-5 d-flex justify-content-center">
      <div class="col-12 col-sm-6 mb-4">

        <div class="card mx-auto border-0" style="max-width: 28rem;">
          <img src="/img/pre/dummyProduct.jpg" class="card-img-top" alt="">
          <div class="card-body text-center pt-5 pb-5">
            <h5 class="card-title">Producto</h5>
            <p class="card-text">sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus</p>
            <a href="#" class="btn btn-primary">COMPRAR</a>
          </div>
        </div>

      </div>

      <div class="col-12 col-sm-6 mx-auto mb-4">

        <div class="card mx-auto border-0" style="max-width: 28rem;">
          <img src="/img/pre/dummyProduct.jpg" class="card-img-top" alt="">
          <div class="card-body text-center pt-5 pb-5">
            <h5 class="card-title">Producto</h5>
            <p class="card-text">sed viverra tellus in hac habitasse platea dictumst vestibulum rhoncus</p>
            <a href="#" class="btn btn-primary">COMPRAR</a>
          </div>
        </div>

      </div>


    </div>



  </div>
</template>

<script>
export default {
  name: "OfferCards",
    data(){
    return{
      im: "Mobile",
      subim: "Texto descriptivo de la categoría de dispositivos móviles Samsung",
      tvav: "TV & Audio",
      subtvav: "Texto descriptivo de la categoría de dispositivos de audio y video Samsung",
      da: "Electrodomésticos",
      subda: "Texto descriptivo de la categoría de Electrodomésticos Samsung",
    }
    }
}
</script>

<style scoped>

#offer-cards {
  min-height: 300px;
}

.card {
  background-color: #f4f4f4;
  border-radius: 15px;
}

.card-img-top{
  border-radius: 15px 15px 0px 0px;
}

</style>